<div class="location-rates-dialog">
  <div class="dialog-header">
    <h2>Rate Table</h2>
    <div class="actions">
      <button mat-stroked-button (click)="copyToClipboard()">
        <mat-icon>content_copy</mat-icon>
        Copy
      </button>
      <button mat-stroked-button (click)="addRow()">
        <mat-icon>add</mat-icon>
        Add Row
      </button>
    </div>
  </div>

  <div class="table-container" (paste)="onPaste($event)">
    <!-- Loading Indicator -->
    <div *ngIf="isLoading" class="loading-overlay">
      <mat-spinner diameter="50"></mat-spinner>
      <p class="loading-text">{{ loadingMessage }}</p>
    </div>
    
    <!-- Fixed Header Table -->
    <table class="rates-table-header">
      <thead class="rates-header">
        <tr class="header-row">
          <th class="location-header" rowspan="2" (paste)="onColumnPaste($event, null, 'location')">
            <div class="location-header-container">
              <span>Location</span>
              <div class="column-actions">
                <button mat-icon-button class="column-copy-button" (click)="copyColumn(null, 'location')" title="Copy location column">
                  <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-icon-button class="column-paste-button" (click)="pasteColumn(null, 'location')" title="Paste location column">
                  <mat-icon>content_paste</mat-icon>
                </button>
                <button mat-icon-button class="refresh-button" (click)="onRefresh()">
                  <mat-icon>sync</mat-icon>
                </button>
              </div>
            </div>
          </th>
          <ng-container *ngFor="let locationColumn of locationColumns; let colIndex = index">
            <th colspan="2" class="location-header location-column-header">
              <form [formGroup]="getLocationForm(colIndex)" class="location-form">
                <mat-form-field class="location-input">
                  <mat-label>Location</mat-label>
                  <input type="text"
                         placeholder="Enter Location"
                         aria-label="Location"
                         matInput
                         formControlName="location"
                         [matAutocomplete]="auto"
                         (input)="onLocationSearch($event, colIndex)">
                  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" 
                                  [displayWith]="displayLocationName"
                                  (optionSelected)="updateLocation(colIndex)">
                    <mat-option *ngFor="let option of getFilteredLocations(colIndex)" [value]="option">{{ option.locationName }}</mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <div class="set-button-container">
                  <button mat-icon-button color="warn" class="remove-column-button" 
                          (click)="removeColumn(colIndex)"
                          *ngIf="locationColumns.length > 1">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </form>
            </th>
          </ng-container>
          <th class="add-column-header" rowspan="2">
            <button mat-icon-button class="add-column-button" (click)="addColumn()">
              <mat-icon>add</mat-icon>
            </button>
          </th>
        </tr>
        <tr class="subheader-row">
          <ng-container *ngFor="let locationColumn of locationColumns; let colIndex = index">
            <th class="distance-header" (paste)="onColumnPaste($event, colIndex, 'distance')" matTooltip="You can copy/paste entire column values">
              Distance
              <div class="column-actions">
                <button mat-icon-button class="column-copy-button" (click)="copyColumn(colIndex, 'distance')" title="Copy distance column">
                  <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-icon-button class="column-paste-button" (click)="pasteColumn(colIndex, 'distance')" title="Paste distance column">
                  <mat-icon>content_paste</mat-icon>
                </button>
              </div>
            </th>
            <th class="rate-header" (paste)="onColumnPaste($event, colIndex, 'rate')" matTooltip="You can copy/paste entire column values">
              Rate
              <div class="column-actions">
                <button mat-icon-button class="column-copy-button" (click)="copyColumn(colIndex, 'rate')" title="Copy rate column">
                  <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-icon-button class="column-paste-button" (click)="pasteColumn(colIndex, 'rate')" title="Paste rate column">
                  <mat-icon>content_paste</mat-icon>
                </button>
              </div>
            </th>
          </ng-container>
        </tr>
      </thead>
    </table>

    <!-- Scrollable Body with Virtual Scroll -->
    <cdk-virtual-scroll-viewport 
      #virtualViewport
      itemSize="72" 
      class="virtual-viewport"
      [class.loading]="isLoading">
      <table class="rates-table-body">
        <tbody class="rates-body">
          <tr *cdkVirtualFor="let rate of locationRates; let i = index; trackBy: trackByIndex" class="location-row">
          <td class="location-cell" (paste)="onCellPaste($event, 'location', i)">
            <mat-form-field appearance="outline">
              <input matInput [(ngModel)]="rate.location" placeholder="Enter location"
                     (ngModelChange)="onLocationRowUpdate(i)"
                     (paste)="onCellPaste($event, 'location', i)" title="">
            </mat-form-field>
          </td>
          <ng-container *ngFor="let locationColumn of locationColumns; let colIndex = index">
              <td class="distance-cell" (paste)="onCellPaste($event, 'distance', i, colIndex)">
              <mat-form-field appearance="outline">
                <input matInput type="text"
                       [ngModel]="getTempDistance(i, colIndex)"
                       (ngModelChange)="onDistanceInput($event, i, colIndex)"
                       (blur)="onInputBlur($event, i, colIndex, 'distance')"
                       placeholder="Enter distance"
                       (paste)="onCellPaste($event, 'distance', i, colIndex)"
                       title="">
              </mat-form-field>
            </td>
              <td class="rate-cell" (paste)="onCellPaste($event, 'rate', i, colIndex)">
              <mat-form-field appearance="outline">
                <input matInput type="text" 
                       [ngModel]="getTempRate(i, colIndex)"
                       (ngModelChange)="onRateInput($event, i, colIndex)"
                       (blur)="onInputBlur($event, i, colIndex, 'rate')"
                       placeholder="Enter rate"
                       (paste)="onCellPaste($event, 'rate', i, colIndex)"
                       title="">
              </mat-form-field>
            </td>
          </ng-container>
          <td>
            <button mat-icon-button color="warn" (click)="removeRow(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    </cdk-virtual-scroll-viewport>
  </div>

  <div class="dialog-footer">
    <div class="paste-instructions">
      <p>Tip: You can paste data directly from Excel or other spreadsheets (Ctrl+V)</p>
      <p>You can also copy/paste entire columns using the buttons in each column header</p>
    </div>
    <div class="footer-actions">
      <button mat-stroked-button (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" (click)="onSave()">Save</button>
    </div>
  </div>
</div> 